import { ConciergeContextSettingsParser } from "@redotech/redo-model/concierge-settings/context-settings-db-parser";
import * as z from "zod/v4";

export const getConciergeContextSettings = {
  name: "getConciergeContextSettings" as const,
  input: z.null(),
  output: z.object({
    conciergeContextSettings: ConciergeContextSettingsParser.optional(),
  }),
};
